import axios, { AxiosResponse, AxiosError } from 'axios'
import * as V1Api from './generated'
import { Configuration } from './generated'

const baseURL = window.location.origin

const getCSRFToken = (): string => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute('content') || ''
}

const configuration = new Configuration({
  apiKey: (name: string) => {
    if (name === 'X-CSRF-TOKEN') {
      return getCSRFToken()
    }
    return ''
  },
  baseOptions: {
    headers: {
      // OpenAPI Generatorが自動設定するUser-Agentヘッダーを削除
      // （ブラウザではJavaScriptからUser-Agentを設定できないため）
      'User-Agent': undefined
    }
  }
})

const axiosInstance = axios.create({
  baseURL,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  responseType: 'json',
})

function isBadRequestError(response: AxiosResponse):
  response is AxiosResponse<V1Api.BadRequestError>
{
  return response.status === 400
}

function isUnauthorizedError(response: AxiosResponse):
  response is AxiosResponse<V1Api.UnauthorizedError>
{
  return response.status === 401
}

function isNotFoundError(response: AxiosResponse):
  response is AxiosResponse<V1Api.NotFoundError>
{
  return response.status === 404
}

function isUnprocessableEntityError(response: AxiosResponse):
  response is AxiosResponse<V1Api.UnprocessableEntityError>
{
  return response.status === 422
}

function isConflictError(response: AxiosResponse):
  response is AxiosResponse<V1Api.ConflictError>
{
  return response.status === 409
}

 
function isAxiosError(error: any): error is AxiosError {
   
  return axios.isAxiosError(error)
}

const API = {
  ...V1Api.V1ApiFactory(configuration, baseURL, axiosInstance),
  isBadRequestError,
  isUnauthorizedError,
  isNotFoundError,
  isUnprocessableEntityError,
  isConflictError,
  isAxiosError,
}

export { API, axiosInstance }
